module.exports = __webpack_public_path__ + "media/images/success/3-278bb7b0c89b071b828783ea80023d1f.png";